import { removeTable_v2, generateTableUpdated_v2 } from './initialize-sdt';
import { Sortable } from 'sortablejs'

var listItemStyle = "padding-left: 3px !important;padding:10px;border-bottom:1px solid rgba(0,0,0,.15);";
var viewButtonStyle = "color:black;border:1px solid #dadada;padding:10px;cursor:pointer;width:100%;text-align:left;background:white;outline:none;";
var searchTerm = '';
window.globalTileColor = "rgb(67, 123, 235)";
window.filterDataCount = '';
window.countViewName = '';
window.defaultView = '';

// /***************************** Getting Filter Data Count ************************************ */
export const getFilteredDataCount = function (filteredCount, viewName) {
	window.filterDataCount = filteredCount;
	window.countViewName = viewName;
}

/***************************** Setting Tile Color according to theme ************************************ */
export const setTileColor = function (color) {
	window.globalTileColor = color;
}

/***************************** Settings Menu ************************************ */
export const showTableHeadsMenu_v2 = function (pageID) {

	var menuDiv = document.getElementById('table-heads-menu#' + pageID);
	if (menuDiv.style.display == "none") {

		menuDiv.style.display = "block";
	}
	else {
		menuDiv.style.display = "none";
	}
}

export const createMenu_v2 = function (tableHeads, pageID, data) {

	window.pageId = pageID;

	if (!tableHeads) return;

	var menuDiv = document.getElementById('table-heads-menu#' + pageID);
	var list = document.getElementById('sh-setting-list');
	if (list != null) {
		list.id = "sh-setting-list#" + pageID;
	}
	else {
		list = document.getElementById("sh-setting-list#" + pageID);
	}

	/**********************Columns Name*****************************/
	var divInput = document.createElement('div');
	divInput.id = "div_input#" + pageID;
	divInput.style = "font-size:12px;text-align:left;font-weight:bold;padding:10px;"
	var label = document.createTextNode("Available Columns: ");
	divInput.appendChild(label);
	menuDiv.prepend(divInput);

	/**********************Generate Menu*****************************/
	tableHeads.forEach((head) => {
		var listItem = document.createElement('li');
		if (listItem.id != "listItem#" + pageID) {
			listItem.id = "listItem#" + pageID;
		}
		listItem.style = listItemStyle;

		var checkBox = document.createElement('input');
		checkBox.id = head.fieldName;
		checkBox.type = "checkbox";

		if (checkBox.id != head.fieldName + '#' + pageID) {
			checkBox.id = head.fieldName + '#' + pageID;
		}

		if (head.checked) {
			checkBox.setAttribute("checked", head.checked);
		}

		listItem.appendChild(checkBox);
		var span = document.createElement('span');
		span.appendChild(document.createTextNode(head.labelName));
		span.style = "font-size:12px;margin-left:2px;vertical-align: middle;";
		listItem.appendChild(span);
		list.appendChild(listItem);
	});

	/**********************Initialize Click Event of Check Box*****************************/
	tableHeads.forEach((head) => {
		if (head != null) {
			head.fieldName = head.fieldName + '#' + pageID;
		}
		else {
			document.getElementById(head.fieldName + '#' + pageID);
		}

		document.getElementById(head.fieldName).onclick = function () {

			let updatedHead = head;
			let checkedFlag = this.checked;

			tableHeads.forEach((existingHead) => {
				if (updatedHead.fieldName == existingHead.fieldName) {
					existingHead.checked = checkedFlag;
					return;
				}
			});
		};
	}
	);

	/**********************Intialize Click Event of Save Button*****************************/
	var saveButton = document.getElementById('sh-save-btn');
	if (saveButton != null) {
		saveButton.id = 'saveButton#' + pageID;
	}
	else {
		saveButton = document.getElementById('saveButton#' + pageID);
	}

	// saveButton.onclick = function (){
	// 	processSave(1);
	// };
	/**********************Intialize Click Event of Save As Button*****************************/
	var saveAsButton = document.getElementById('sdt-savas-btn');
	if (saveAsButton != null) {
		saveAsButton.id = 'saveAsButton#' + pageID;
	}
	else {
		saveAsButton = document.getElementById('saveAsButton#' + pageID);
	}

	// saveAsButton.onclick = function (){
	// 	processSave(2);
	// };

	/**********************Intialize Click Event of New Button*****************************/
	var applyButton = document.getElementById('sdt-apply');
	if (applyButton != null) {
		applyButton.id = 'applyButton#' + pageID;
	}
	else {
		applyButton = document.getElementById('applyButton#' + pageID);
	}

	// applyButton.onclick = function (){
	// 	removeTable_v2(pageID);
	// 	window.globalTableHeads_v2 = window.tempTableHeadList_v2;
	// 	generateTableUpdated_v2(window.hoverButtons_v2,window.selectType_v2,window.selectionColumn_v2,pageID,tableHeads,data,window.density_v2,window.globalHeight_v2,window.globalSortField_v2,window.globalSortDirection_v2,window.globalViews_v2,window.globalCurrentView_v2);
	// };

	/**********************Intialize Click Event of Delete Button*****************************/
	var delButton = document.getElementById('sh-del-btn');
	if (delButton != null) {
		delButton.id = 'delButton#' + pageID;
	}
	else {
		delButton = document.getElementById('delButton#' + pageID);
	}

	// delButton.onclick = function (){
	// 	var event = new CustomEvent("deleteViewEvent");
	// 	window.dispatchEvent(event);
	// };

	/**********************Intialize Click Event of Add to Tiles Button*****************************/
	var tileButton = document.getElementById('sh-tile-btn');
	if (tileButton != null) {
		tileButton.id = 'tileButton#' + pageID;
	}
	else {
		tileButton = document.getElementById('tileButton#' + pageID);
	}

	// tileButton.onclick = function(){addTile()};

	/**********************Intialize Click Event of Search Button*****************************/
	// var searchButton = document.getElementById('srch-btn');
	// if(searchButton != null){
	// 	searchButton.id = 'searchButton#'+pageID;
	// }
	// else{
	// 	searchButton = document.getElementById('searchButton#'+pageID);
	// }

	// searchButton.onclick = function (){

	// 	var searchBar = document.getElementById('search-bar');
	// 	if(searchBar != null){
	// 		searchBar.id = 'searchBar#'+pageID;
	// 	}
	// 	else{
	// 		searchBar = document.getElementById('searchBar#'+pageID);
	// 	}

	// 	window.globalSearchValue = searchBar.value;
	// 	window.console.log(	window.globalSearchValue)
	// 	var event = new CustomEvent("searchEvent");
	// 	window.dispatchEvent(event);
	// };

	/**********************Intialize Click Event of Default Button*****************************/
	var defButton = document.getElementById('sh-def-btn');
	if (defButton != null) {
		defButton.id = 'defButton#' + pageID;
	}
	else {
		defButton = document.getElementById('defButton#' + pageID);
	}

	// defButton.onclick = function (){
	// 	var event = new CustomEvent("defaultViewEvent");
	// 	window.dispatchEvent(event);
	// };

	/**********************Intialize Click Event of System Default View Button*****************************/
	var systemDefViewButton = document.getElementById("sh-system-def-btn");
	if (systemDefViewButton != null) {
		systemDefViewButton.id = 'systemDefViewButton#' + pageID;
	}
	else {
		systemDefViewButton = document.getElementById('systemDefViewButton#' + pageID);
	}

	// systemDefViewButton.onclick = function(){
	// 	var event = new CustomEvent("systemDefaultViewEvent");
	// 	window.dispatchEvent(event);
	// };

	/**********************Intialize Sort*****************************/
	// Sortable.create(list, {
	//   	group: "sorting",
	//   	sort: true,
	//   	onEnd: function (/**Event*/evt) {

	//   		var oldIndex = evt.oldIndex;
	//   		var newIndex = evt.newIndex;
	// 		var itemEl = evt.item.innerText;  // dragged HTMLElement
	// 		var selectedItem = window.tempTableHeadList_v2[oldIndex];

	// 		if(oldIndex>newIndex){

	// 			for(var i=oldIndex-1;i>=newIndex;i--){

	// 				window.tempTableHeadList_v2[i+1] = window.tempTableHeadList_v2[i];
	// 			}

	// 			window.tempTableHeadList_v2[newIndex]=selectedItem;
	// 		}
	// 		else if(oldIndex<newIndex){

	// 			for(var i=oldIndex+1;i<=newIndex;i++){
	// 				window.tempTableHeadList_v2[i-1] = window.tempTableHeadList_v2[i];
	// 			}

	// 			window.tempTableHeadList_v2[newIndex]=selectedItem;
	// 		}
	// 	}
	// });
}

function processSave(eventType) {

	var event = new CustomEvent("saveViewEvent");

	/******** setting resizable elements in temp table heads *********/
	for (var j = 1, k = 2; j < window.globalResizedElements_v2.length; j++, k++) {
		for (var i = 0; i < window.tempTableHeadList_v2.length; i++) {
			if (window.globalResizedElements_v2[j] == window.tempTableHeadList_v2[i].labelName) {
				window.tempTableHeadList_v2[i].width = window.globalResizedElements_v2[k];
				break;
			}
		}
		j++;
		k++;
	}
	window.msg_v2 = eventType;//save
	window.dispatchEvent(event);
}

/**********************Initialize Click Event of Search Button*****************************/
export const initializeTableSearch = function (pageID) {

	var searchButton = document.getElementById('srch-btn');
	var searchInput = document.getElementById('search-bar');
	if (searchButton != null) {
		searchButton.id = 'searchButton#' + pageID;
	}
	else {
		searchButton = document.getElementById('searchButton#' + pageID);
	}

	searchButton.onclick = function () {
		var searchBar = document.getElementById('search-bar');
		if (searchBar != null) {
			searchBar.id = 'searchBar#' + pageID;
		}
		else {
			searchBar = document.getElementById('searchBar#' + pageID);
		}

		window.globalSearchValue = searchBar.value;
		// window.console.log(	window.globalSearchValue)
		var event = new CustomEvent("searchEvent");
		window.dispatchEvent(event);
	};

	searchInput.oninput = function () {
		var searchBar = document.getElementById('search-bar');
		if (searchBar != null) {
			searchBar.id = 'searchBar#' + pageID;
		}
		else {
			searchBar = document.getElementById('searchBar#' + pageID);
		}

		window.globalSearchValue = searchBar.value;
		// window.console.log(	window.globalSearchValue)
		var event = new CustomEvent("searchEvent");
		window.dispatchEvent(event);
	}
}

/***************************** Views Menu ************************************ */
export const showViewsMenu_v2 = function (pageID) {
	var viewSpan = document.getElementById('sh-views#' + pageID);
	if (viewSpan.style.display == "none") {
		viewSpan.style.display = "block";
	}
	else {
		viewSpan.style.display = "none";
	}
}
//Also creates tiles
export const createViews_v2 = function (pageID, globalViews_v2, currentView) {
	// let viewSpan = document.getElementById("sh-views");
	// if(viewSpan == null){
	// 	viewSpan = document.getElementById("sh-views#" + window.GlobalId_v2);
	// }
	//var viewSpan = document.getElementById('sh-views#' + pageID);

	// var divTag = document.createElement('div');
	// divTag.style="padding:10px;font-weight: bold;text-align:center;";
	// divTag.appendChild(document.createTextNode("My Custom Views"));
	// viewSpan.appendChild(divTag);
	sortViewsByOrderPosition(globalViews_v2);
	for (var n = 0; n < globalViews_v2.length; n++) {

		// var optionButton = document.createElement('button');
		// optionButton.id = "btn";
		// optionButton.style = viewButtonStyle;

		// if(globalViews_v2[n].name == currentView){
		// 	optionButton.style.color = "black";
		// 	optionButton.style.fontWeight = 700;
		// 	optionButton.style.background = '#434343';
		// }

		// optionButton.appendChild(document.createTextNode(globalViews_v2[n].name));
		// viewSpan.appendChild(optionButton);

		if (globalViews_v2[n].tileFlag) {

			addTileToList(globalViews_v2[n].name);
		}

	}
	let allTiles = document.getElementById('tiles#' + pageID);

	Sortable.create(allTiles, {
		group: "sorting",
		sort: true,
		direction: 'horizontal',

		onEnd: function (evt) {
			// console.log(evt)
			var oldIndex = evt.oldIndex;
			var newIndex = evt.newIndex;
			var itemEl = evt.item.innerText;  // dragged HTMLElement
			var selectedItem = globalViews_v2[oldIndex];

			if (oldIndex > newIndex) {

				for (var i = oldIndex - 1; i >= newIndex; i--) {

					globalViews_v2[i + 1] = globalViews_v2[i];
				}

				globalViews_v2[newIndex] = selectedItem;
			}
			else if (oldIndex < newIndex) {

				for (var i = oldIndex + 1; i <= newIndex; i++) {
					globalViews_v2[i - 1] = globalViews_v2[i];
				}

				globalViews_v2[newIndex] = selectedItem;
			}

			let temp = globalViews_v2;
			// removing undefined from array
			temp = temp.filter(function (x) {
				return x !== undefined;
			});

			for (let s = 0; s < temp.length; s++) {
				const viewtile = temp[s];

				if (viewtile.name === 'Add A View Tile') {
					temp.splice(s, 2);
				}
			}

			let counter = 2; //starting counter from 2 because of add view and default tile.
			// resetting positions of views
			for (let j = 0; j < temp.length; j++, counter++) {
				console.log(temp[j].name + ' ' + temp[j].position)
				temp[j].position = counter;
			}

			var event = new CustomEvent("saveViewsOrder", { detail: temp });
			window.dispatchEvent(event);
		}

	});

	// viewSpan.addEventListener('click',selectView,true);
}

function sortViewsByOrderPosition(views) {
	views.sort((a, b) => parseFloat(a.position) - parseFloat(b.position));
}

export const selectView = function (event) {
	window.globalCurrentView_v2 = event.target.innerText;
	var event = new CustomEvent("selectViewEvent");
	showViewsMenu_v2(window.GlobalId_v2);
	window.dispatchEvent(event);
}

function addTileToList(viewName) {

	var tilesDiv = document.getElementById('tiles');
	if (tilesDiv != null) {
		tilesDiv.id = "tiles#" + window.GlobalId_v2;
	}
	else {
		tilesDiv = document.getElementById('tiles#' + window.GlobalId_v2);
	}

	let parentTileDiv = document.createElement('div');
	parentTileDiv.style = "display: block; margin: 0px 0px -32px 0px; ";

	let tileDiv = document.createElement('div');
	tileDiv.style = "box-sizing: border-box;border-radius: 1px; margin: 40px 4px -149px 0px; padding:14px 10px 20px; background-color:#f4f4f4; width:155px; height: 100px; border: 1px solid #979797";
	tileDiv.addEventListener("mouseover", function(event) {
	tileDiv.style.cursor = "move";

	});

	// tileDiv.style.background = window.globalTileColor;

	// if(viewName == "Default View"){
	// 	window.filterDataCount = "";
	// }

	// let mainDiv = document.createElement('div');

	// let crossDiv = document.createElement('div');
	// crossDiv.style.float = "right";
	// crossDiv.style.display = "grid";

	// let crossImage = document.createElement('img');
	// // crossImage.src = require("@/shared/assets/icons/v2/del-btn-wh.png");
	// crossImage.id = viewName+"#"+window.GlobalId_v2;
	// crossImage.style.height = "10px";

	// crossDiv.appendChild(crossImage);

	let anchorTag = document.createElement('a');
	anchorTag.href = "javascript:void(0);";
	if (viewName == 'Default View') {
		anchorTag.appendChild(document.createTextNode('SYSTEM VIEW'));
		if (window.globalCurrentView_v2 != 'Default View') {
			anchorTag.style = "vertical-align: top;color:black;font-weight:bold;text-decoration: none; font-size: 10px;font-family: Roboto; text-transform: uppercase;";
			tileDiv.style = "box-sizing: border-box;border-radius: 1px;margin: 40px 4px -149px 0px; padding:14px 10px 20px;background-color:#f4f4f4;width:155px;height: 100px;";
			// if clicked onsystem view then show selected design
			if (window.globalCurrentView_v2 == 'SYSTEM VIEW') {
				anchorTag.style = "vertical-align: top;color:white;font-weight:bold;text-decoration: none; font-size: 10px;font-family: Roboto; text-transform: uppercase;";
				tileDiv.style = "box-sizing: border-box;border-radius: 1px;margin: 40px 4px -149px -20px; padding:14px 10px 20px;background-color:#434343;width:155px;height: 100px;";
			}
		}
		else {
			anchorTag.style = "vertical-align: top;color:white;text-decoration: none; font-size: 10px;font-family:Roboto; text-transform: uppercase;";
		}
	}
	else if (viewName == 'Add A View Tile') {
		tileDiv.style = "box-sizing: border-box;border-radius: 1px;margin: 40px 4px 40px 0; padding:16px 16px 20px;background-color:#ffffff;width:160px;height: 100px;border: 1px solid #e1e1e1;";
		anchorTag.appendChild(document.createTextNode('ADD A VIEW TILE'));
		anchorTag.style = "vertical-align: top;cursor:not-allowed;color:black;font-weight:bold;text-decoration: none; font-size: 10px;font-family: Roboto; text-transform: uppercase;";
	}
	else {
		anchorTag.appendChild(document.createTextNode(viewName));
		tileDiv.style = "box-sizing: border-box;border-radius: 1px;margin: 40px 4px 40px 0; padding:16px 16px 20px;background-color:#f4f4f4;width:160px;height: 100px;";
		anchorTag.style = "vertical-align: top;color:black;font-weight:bold;text-decoration: none; font-size: 10px;font-family: Roboto; text-transform: uppercase;";
	}

	tileDiv.appendChild(anchorTag);

	let viewCreatorDiv = document.createElement('div');
	viewCreatorDiv.style = 'display: inline-flex;';

	// setting view creator details
	let viewCreator = document.createElement('span');
	viewCreator.style = "font-size: 10px; font-family: Roboto; color: #979797;display: block; max-width: 110px; margin-top: 8px;"

	let privacyImg = document.createElement('img');

	if (viewName == 'Default View') {
		// if(window.globalViews_v2.length==2){
		// 	viewCreator.appendChild(document.createTextNode('Default'));
		// }
	}
	else if (viewName == 'Add A View Tile') {
		// add plus image
		let add = document.createElement('img');
		add.style = "width:16px;height:16px;cursor:pointer;position: relative; left: -78px; top: 35px;";
		add.src = require("../../assets/Add.png");
		add.id = 'tileButton#' + window.GlobalId_v2;

		add.onclick = function () {
			var event = new CustomEvent("addNewViewEvent");
			window.dispatchEvent(event);
		};
		tileDiv.appendChild(add);
	}
	else {
		//adding view creator details
		let user = '';
		for (let i = 2; i < window.globalViews_v2.length; i++) {
			if (window.globalViews_v2[i].name == viewName) {
				user = window.globalViews_v2[i].createdBy;
			}
		}
		let splitName = user.split('@');
		splitName = splitName[0].split('.');
		user = splitName[0] + ' ' + splitName[1];
		user = titleCase(user);
		user = user[0] + ' ' + user[1];
		viewCreator.appendChild(document.createTextNode('Created By ' + user));

		// adding privacy image
		for(let i=2; i<window.globalViews_v2.length; i++){
			if(window.globalViews_v2[i].name == viewName){
				privacyImg.style = "width:16px; height:16px; cursor:pointer; margin-left:7px;margin-top: 8px;";
				if(window.globalViews_v2[i].privacy == 'public'){
					if(window.globalCurrentView_v2 == viewName){
						privacyImg.src = require("../../assets/sdt-icons/white-public.png");
					}
					else {
						privacyImg.src = require("../../assets/sdt-icons/public.png");
					}
				}
				if (window.globalViews_v2[i].privacy == 'private') {
					if (window.globalCurrentView_v2 == viewName) {
						privacyImg.src = require("../../assets/sdt-icons/white-private.png");
					}
					else {
						privacyImg.src = require("../../assets/sdt-icons/private.png");
					}
				}
				break;
			}
		}
		viewCreator.appendChild(privacyImg);
	}

	viewCreatorDiv.appendChild(viewCreator);
	viewCreatorDiv.appendChild(privacyImg)
	tileDiv.appendChild(viewCreatorDiv);

	// edit/del view hovericons
	let hoverIcons = document.createElement('div');
	hoverIcons.style = "display: none; grid-template-columns: 1.5fr 1.5fr;background-color: #ffffff; box-shadow: 0 0 5px 0 rgba(0,0,0,0.25);border-radius:5px;padding:7px 5px 7px 5px;text-align:-webkit-center;width: 60px; height: 16px; position: relative;top: -80px;right:-62px;";
	let edit = document.createElement('img');
	edit.src = require('../../assets/sdt-icons/Edit.png');
	edit.style = "width: 16px;height:16px;opacity:0.5;cursor:pointer;";
	edit.id = viewName + "#" + window.GlobalId_v2;

	let del = document.createElement('img');
	del.src = require('../../assets/sdt-icons/Delete.png');
	del.style = "width: 16px;height:16px;opacity:0.5;cursor:pointer;";
	del.id = viewName + "#" + window.GlobalId_v2;
	hoverIcons.appendChild(edit);
	hoverIcons.appendChild(del);
	// not showing hover icons for system tile and add view tile
	if (viewName != 'Default View' && viewName != 'Add A View Tile') {
		let user = '';
		for (let i = 2; i < window.globalViews_v2.length; i++) {
			if (window.globalViews_v2[i].name == viewName) {
				user = window.globalViews_v2[i].createdBy.split('@');
				user = user[0];
				user = user.split('.');
				user = user[0];

				//showing edit/del icons only for views
				//created by current logged in user
				if (!window.user.toLowerCase().includes(user)) {
					tileDiv.appendChild(hoverIcons);
				}
			}
		}
	}

	tileDiv.addEventListener('mouseover', function (e) {
		hoverIcons.style.display = 'grid';
		hoverIcons.style.top = '-70px';
	});

	tileDiv.addEventListener('mouseout', function (e) {
		hoverIcons.style.display = 'none';
	});

	edit.onclick = function () {
		// processSave(1);
		let id = edit.id;
		let name = id.split('#');
		name = name[0];

		var evt = new CustomEvent("editViewEvent", { 'detail': name });
		window.dispatchEvent(evt);
	};
	del.onclick = function () {
		let id = del.id;
		let name = id.split('#');
		name = name[0];
		window.globalCurrentView_v2 = name;
		var evt = new CustomEvent("deleteViewEvent");
		window.dispatchEvent(evt);
	};

	// showing set as default for selected view tile
	let setDefaultText = document.createElement('p');
	setDefaultText.innerText = 'Set as Default View';
	setDefaultText.style = "position: relative; top:-32px; left: 2px; text-decoration: underline; font-size:10px; font-family:Roboto; color:black; cursor:pointer;";

	setDefaultText.onclick = function () {
		var event = new CustomEvent("setAsDefaultViewEvent");
		window.dispatchEvent(event);
	};

	if (window.defaultView == viewName && viewName != 'Default View') {
		viewCreator.appendChild(document.createTextNode(' (Default)'));
	}

	if (window.defaultView != viewName) {
		tileDiv.addEventListener('mouseover', function (e) {
			hoverIcons.style.display = 'grid';
			hoverIcons.style.top = '-70px';
		});
	}

	parentTileDiv.appendChild(tileDiv);

	// current selected tile
	if (viewName == window.globalCurrentView_v2) {
		tileDiv.style.background = "#434343";
		anchorTag.style.color = "white";

		if (window.defaultView != viewName) {
			parentTileDiv.appendChild(setDefaultText);
		}

		if (viewName != window.defaultView) {
			tileDiv.addEventListener('mouseover', function (e) {
				hoverIcons.style.display = 'grid';
				hoverIcons.style.top = '-70px';
			});
		}
		else {
			tileDiv.addEventListener('mouseover', function (e) {
				hoverIcons.style.display = 'grid';
				hoverIcons.style.top = '-80px';
			});
		}
	}

	tilesDiv.appendChild(parentTileDiv);
	window.globalTiles.push(viewName);

	for (let i = 0; i < window.globalViews_v2.length; i++) {
		if (viewName == window.globalViews_v2[i].name) {
			window.globalViews_v2[i].tileFlag = true;
			break;
		}
	}

	anchorTag.addEventListener('click', (event) => {
		window.globalCurrentView_v2 = event.target.innerText;
		var event = new CustomEvent("selectViewEvent");
		window.dispatchEvent(event);
	});
}
function addTile() {
	let foundFlag = false;

	for (let i = 0; i < window.globalTiles.length; i++) {
		if (window.globalTiles[i] == window.globalCurrentView_v2) {
			foundFlag = true;
			break;
		}
	}

	if (!foundFlag) {
		addTileToList(window.globalCurrentView_v2)
	}

}

function getSearchTerm_v2() {
	return searchTerm;
}

function titleCase(string) {
	var sentence = string.toLowerCase().split(" ");
	for (var i = 0; i < sentence.length; i++) {
		sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
	}
	return sentence;
}
